import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, XCircle } from 'lucide-react';

export default function MentorOnboardingResultPage({ status }) {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const mentorId = params.get('mentor_id');
    const email = params.get('email');
    const message = params.get('msg');

    return (
        <div className="relative min-h-screen bg-noise bg-hero-soft">
            <div className="mx-auto flex min-h-screen max-w-lg items-center px-4 py-16 sm:px-6">
                <Card className="w-full border-border/60 shadow-lg">
                    <CardContent className="p-8 text-center">
                        {status === 'success' ? (
                            <>
                                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
                                    <CheckCircle2 className="h-7 w-7" />
                                </div>
                                <h1 className="font-display text-2xl font-semibold">Calendar connected!</h1>
                                <p className="mt-2 text-sm text-muted-foreground">
                                    Great work {email && <>— <strong>{email}</strong></>}. Students can now book real-time slots based on your Google Calendar. You can close this tab.
                                </p>
                                {mentorId && (
                                    <Button variant="secondary" className="mt-6" onClick={() => navigate(`/mentor-onboarding/${mentorId}`)}>
                                        View my onboarding status
                                    </Button>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10 text-destructive">
                                    <XCircle className="h-7 w-7" />
                                </div>
                                <h1 className="font-display text-2xl font-semibold">Something went wrong</h1>
                                <p className="mt-2 text-sm text-muted-foreground">
                                    {message ? decodeURIComponent(message) : 'We couldn’t connect your Google Calendar.'} Please try again or contact your admin.
                                </p>
                            </>
                        )}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
